import {Form as FormInicial, message, Tag, Typography, Tooltip, Empty, Alert } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    FormItem,
    InputNumberItem,
    ModalItem,
    ButtonItem,
    ErrorItem,
    round10Decimals,
} from "../../../../Components/Items";
import EstadosLeyenda from "../../../../Components/EstadosLeyenda";
import axios from "axios";
import moment from "moment";

const { Text } = Typography;

class ElegirLotes extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        lotes: [],
        insumo: {},
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarLotesRestantes()
        }
    }

    // Suma de lo capturado, para el aviso de faltante y la validacion del modo "exacta"
    sumaCapturada(lotes) {
        const lista = Array.isArray(lotes) ? lotes : []
        return round10Decimals(lista.reduce((suma, lote) => suma + (Number(lote?.cantidadRequerida) || 0), 0))
    }

    propagar(lotes) {
        this.props.cerrarElegirLotes(lotes);
        this.formRef.current.resetFields()
    }

    // Se valida a mano en lugar de usar htmlType="submit" para NO pasar por
    // Form2.handleFinish, cuyo candado antirrepeticion de 5 s se traga el segundo
    // "Confirmar" cuando se capturan dos renglones seguidos: el modal no se
    // desmonta entre aperturas, asi que la instancia del Form persiste.
    confirmarLotes = async () => {
        let values
        try {
            values = await this.formRef.current.validateFields()
        } catch (e) {
            return ErrorItem(e)
        }
        const lotes = Array.isArray(values.lotes) ? values.lotes : []
        const lotesFiltrados = lotes.filter(lote => lote.cantidadRequerida && lote?.cantidadRequerida > 0)

        // modoCantidad "exacta": el desglose por lote ES el movimiento de inventario,
        // asi que tiene que cuadrar con la cantidad del renglon. En el modo "tope"
        // (default) solo se avisa, porque en documentos en construccion la cantidad
        // del renglon todavia puede cambiar despues de cerrar el modal.
        const objetivo = Number(this.props.cantidad)
        if (this.props.modoCantidad === 'exacta' && Number.isFinite(objetivo) && objetivo > 0) {
            const suma = this.sumaCapturada(lotesFiltrados)
            if (Math.abs(suma - objetivo) > 0.0001) {
                return message.warning(
                    `La suma de los lotes (${suma}) debe ser igual a la cantidad del renglon (${objetivo}). Faltan ${round10Decimals(objetivo - suma)}.`
                )
            }
        }

        this.propagar(lotesFiltrados)
    };

    // Cerrar con la X / Esc / boton Cancelar descarta lo capturado y le devuelve al
    // padre EXACTAMENTE lo que ya tenia. No se puede pasar undefined ni omitir la
    // llamada: los consumidores asignan el valor crudo al renglon y cierran el modal
    // en esa misma funcion.
    cancelarLotes = () => {
        this.propagar(this.props.lotes || [])
    };

    async consultarLotesRestantes() {
        this.setState({ loading: true });
        await axios
            .post(
                "lotes/selectLotesDisponibles",
                { 
                    empresaId: this.props.empresaId, 
                    insumoId: this.props.insumoId, 
                    proyectoId: this.props.proyectoId, 
                    clienteId: this.props.clienteId, 
                    cotizacionId: this.props.cotizacionId, 
                    ventaId: this.props.ventaId, 
                    pedidosSeleccionados: this.props.pedidosSeleccionados,
                    
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    //Ordenar por fecha de caducidad, los que no tienen caducidad al final
                    const nuevosLotes = res.data.lotesDisponibles.map(valeuLote => {
                        const loteCatual = this.props?.lotes ? this.props?.lotes?.find(valueTM => valueTM.entradaId.toString() === valeuLote.entradaId.toString()) : undefined
                        // Un lote cuyo saldo no se pudo calcular se muestra deshabilitado y
                        // con max 0. Si arrastrara una cantidad previa, el confirm quedaria
                        // bloqueado por la regla del max SIN que el usuario pueda corregirlo
                        // (el campo esta deshabilitado): se arranca en 0 para que pueda
                        // reasignar esa cantidad a otro lote.
                        const saldoNum = Number(valeuLote?.saldo)
                        const saldoValido = Number.isFinite(saldoNum) && saldoNum >= 0
                        return {
                            ...valeuLote,
                            cantidadRequerida: saldoValido ? (loteCatual?.cantidadRequerida || 0) : 0
                        }
                    }).sort((a, b) => {
                        if (!a.caducidad && !b.caducidad) {
                            return 0;
                        }
                        if (!a.caducidad) {
                            return 1;
                        }
                        if (!b.caducidad) {
                            return -1;
                        }
                        return new Date(a.caducidad) - new Date(b.caducidad);
                    })
                    this.setState({ lotes: nuevosLotes, insumo: res.data.insumo });
                    this.formRef.current.setFieldsValue({
                        lotes: nuevosLotes,
                    })
                } else if (res.data.success === 1) {
                    message.warning(res.data.message)
                } else {
                    message.error('Hubo un error y no se pudo consultar los lotes disponibles')
                }
            });
        this.setState({ loading: false });
    }

    render() {
        const nombreInsumo = this.state.insumo?.descripcion || "Cargando insumo...";
        const codigoInsumo = this.state.insumo?.clave || "";

        return (
            <>
                <ModalItem
                    title={`Elegir Lotes : ${codigoInsumo ? codigoInsumo + ' - ' : ''} ${nombreInsumo}`}
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cancelarLotes}
                    maskClosable={false}
                    paddingTop
                    width={1000}
                >
                    <Form
                        ref={this.formRef}
                        name="elegirLotes"
                        layout
                        bottom={
                            <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 20 }}>
                                <Text type="secondary" style={{ marginRight: "auto", fontSize: 12 }}>
                                    Los cambios se aplican al presionar Confirmar Lotes.
                                </Text>
                                <ButtonItem
                                    rojoB
                                    lessTime
                                    onClick={this.cancelarLotes}
                                    style={{ minWidth: "110px" }}
                                >
                                    Cancelar
                                </ButtonItem>
                                <ButtonItem
                                    type="primary"
                                    lessTime
                                    onClick={this.confirmarLotes}
                                    style={{ minWidth: "120px" }}
                                >
                                    Confirmar Lotes
                                </ButtonItem>
                            </div>
                        }
                    >
                        <EstadosLeyenda estados={[
                            { key: 'apartado', color: '#ffe0a3', label: 'Apartado' },
                            { key: 'sinSaldo', color: '#f5f5f5', label: 'Disponible no calculable' },
                        ]} />
                        <FormItem noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                                const objetivo = Number(this.props.cantidad)
                                if (!Number.isFinite(objetivo) || objetivo <= 0) return null
                                const suma = this.sumaCapturada(getFieldValue('lotes'))
                                const falta = round10Decimals(objetivo - suma)
                                if (falta <= 0) return null
                                return (
                                    <Alert
                                        type="warning"
                                        showIcon
                                        style={{ marginBottom: 10 }}
                                        message={`Asignados ${suma} de ${objetivo}. Faltan ${falta} por asignar.`}
                                    />
                                )
                            }}
                        </FormItem>
                        <FormInicial.List name="lotes">
                            {(fields) => (
                                <div style={{
                                    border: '1px solid #f0f0f0',
                                    borderRadius: '8px', 
                                    overflowX: 'auto',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                                }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                                        {fields.length > 0 ? (
                                            <thead style={{ backgroundColor: '#fafafa', borderBottom: '1px solid #f0f0f0' }}>
                                                <tr>
                                                    <th style={{ padding: '12px 16px', fontWeight: 600, color: '#262626' }}>Número</th>
                                                    <th style={{ padding: '12px 16px', fontWeight: 600, color: '#262626' }}>Fecha</th>
                                                    <th style={{ padding: '12px 16px', fontWeight: 600, color: '#262626' }}>Caducidad</th>
                                                    {this.props.taxidermia && (
                                                        <>
                                                            <th style={{ padding: '12px 16px', fontWeight: 600, color: '#262626' }}>Cliente</th>
                                                            <th style={{ padding: '12px 16px', fontWeight: 600, color: '#262626', textAlign: 'center' }}>Etapa</th>
                                                        </>
                                                    )}
                                                    {this.state.insumo?.vehiculo && (
                                                        <>
                                                            <th style={{ padding: '12px 16px', fontWeight: 600, color: '#262626' }}>Color</th>
                                                            <th style={{ padding: '12px 16px', fontWeight: 600, color: '#262626' }}>Niv</th>
                                                        </>
                                                    )}
                                                    <th style={{ padding: '12px 16px', fontWeight: 600, color: '#262626' }}>Disponible</th>
                                                    <th style={{ padding: '12px 16px', fontWeight: 600, color: '#262626' }}>Cant. Requerida</th>
                                                </tr>
                                            </thead>
                                        ) : null}
                                        
                                        <tbody>
                                            {fields.length === 0 && !this.state.loading && (
                                                <tr>
                                                    <td colSpan="10" style={{ padding: '40px', textAlign: 'center' }}>
                                                        <Empty description="No hay lotes disponibles para este producto" />
                                                    </td>
                                                </tr>
                                            )}
                                            
                                            {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => {
                                                // || {}: state.lotes y el valor del form se desincronizan un tick
                                                // cuando consultarLotesRestantes hace setState + setFieldsValue desde
                                                // un .then (React 17 no batchea fuera de eventos). Si el insumo nuevo
                                                // trae MENOS lotes que el anterior, loteData.saldo revienta el render.
                                                const loteData = this.state.lotes[arrayKey] || {};
                                                const saldoNum = Number(loteData.saldo);
                                                // JSON.stringify(NaN) es "null": un saldo roto en backend llega como
                                                // null, no como NaN. Ambos casos caen aqui.
                                                const saldoValido = Number.isFinite(saldoNum) && saldoNum >= 0;
                                                const max = saldoValido ? round10Decimals(saldoNum) : 0;

                                                return (
                                                    <tr key={key} style={{ borderBottom: '1px solid #f0f0f0', backgroundColor: !saldoValido ? '#f5f5f5' : (loteData.estado === 2 ? '#ffe0a3' : undefined) }}>
                                                        <td style={{ padding: '12px 16px' }}>
                                                            <Text strong style={{ color: '#595959' }}>{loteData.numero}</Text>
                                                        </td>
                                                        <td style={{ padding: '12px 16px' }}>
                                                            <Text type="secondary">{moment(loteData.createdAt).locale("es").format("DD/MM/YYYY")}</Text>
                                                        </td>
                                                        <td style={{ padding: '12px 16px' }}>
                                                            <Text type="secondary" style={{ color: loteData.caducidad ? 'inherit' : '#d9d9d9' }}>
                                                                {loteData.caducidad ? moment(loteData.caducidad).locale("es").format("DD/MM/YYYY") : "-"}
                                                            </Text>
                                                        </td>
                                                        
                                                        {this.props.taxidermia && (
                                                            <>
                                                                <td style={{ padding: '12px 16px' }}>
                                                                    <Text>{loteData.clienteNombre}</Text>
                                                                </td>
                                                                <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                                                                    <Tag color="blue" style={{ margin: 0 }}>{loteData.etapa}</Tag>
                                                                </td>
                                                            </>
                                                        )}
                                                        
                                                        {this.state.insumo?.vehiculo && (
                                                            <>
                                                                <td style={{ padding: '12px 16px' }}>
                                                                    <Text>{loteData.color}</Text>
                                                                </td>
                                                                <td style={{ padding: '12px 16px' }}>
                                                                    <Text>{loteData.niv}</Text>
                                                                </td>
                                                            </>
                                                        )}
                                                        
                                                        <td style={{ padding: '12px 16px' }}>
                                                            {saldoValido ? (
                                                                <Text strong style={{ color: '#00b5e2', fontSize: '15px' }}>{max}</Text>
                                                            ) : (
                                                                <Tooltip title="El sistema no pudo calcular el disponible de este lote porque su movimiento de entrada tiene datos incompletos. No se puede surtir desde este lote; reportalo a soporte.">
                                                                    <Tag color="error" icon={<WarningOutlined />} style={{ margin: 0 }}>Sin dato</Tag>
                                                                </Tooltip>
                                                            )}
                                                        </td>

                                                        <td style={{ padding: '12px 16px' }}>
                                                            <FormItem noStyle shouldUpdate>
                                                                {({ getFieldValue }) => {
                                                                    const lotes = getFieldValue('lotes') || [];
                                                                    const sumOtros = lotes.reduce((s, l, i) => i !== arrayKey ? s + (Number(l?.cantidadRequerida) || 0) : s, 0);
                                                                    const cantidadRenglon = Number(this.props.cantidad);
                                                                    const restante = Number.isFinite(cantidadRenglon) ? Math.max(0, round10Decimals(cantidadRenglon - sumOtros)) : Infinity;
                                                                    const maxEfectivo = Math.min(max, restante);
                                                                    return (
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '160px' }}>
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "cantidadRequerida"]}
                                                                                numberCero
                                                                                noStyle
                                                                                type="number"
                                                                                max={maxEfectivo}
                                                                            >
                                                                                {/* El max del FormItem solo genera una regla de antd que se
                                                                                    evalua al confirmar; hay que pasarselo TAMBIEN al control para
                                                                                    que rc-input-number marque el valor fuera de rango mientras se
                                                                                    escribe y lo recorte al salir del campo. La regla se queda como
                                                                                    red para lo que entra por setFieldsValue (boton "Max") y para
                                                                                    cuando el max baja despues de haber capturado. */}
                                                                                <InputNumberItem
                                                                                    max={maxEfectivo}
                                                                                    min={0}
                                                                                    disabled={!saldoValido}
                                                                                    placeholder={`Máx: ${maxEfectivo}`}
                                                                                    style={{ flex: 1 }}
                                                                                />
                                                                            </FormItem>
                                                                            <Tooltip title="Asignar máximo disponible">
                                                                                <ButtonItem
                                                                                    lima
                                                                                    type="default"
                                                                                    size="small"
                                                                                    disabled={!saldoValido}
                                                                                    onClick={() => {
                                                                                        const updatedLotes = [...this.formRef.current.getFieldValue("lotes")];
                                                                                        updatedLotes[arrayKey].cantidadRequerida = maxEfectivo;
                                                                                        this.formRef.current.setFieldsValue({ lotes: updatedLotes });
                                                                                    }}
                                                                                >
                                                                                    Max
                                                                                </ButtonItem>
                                                                            </Tooltip>
                                                                        </div>
                                                                    );
                                                                }}
                                                            </FormItem>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </FormInicial.List>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(ElegirLotes);